import IconNoProfileImage from "../assets/icons/no-profile-picture.svg?string";
//
import { Table } from ":src/components/list";
import { EmptyTable } from "../components/empty-table";
import { cancel_request } from "../apis";
import { global } from ":shared/app";

//
import type { _Api } from "../../SHARED/_model";
import type { _SolidState } from ":setup/qstate";
import { createMemo } from "solid-js";

export type Props = {
  details: _Api._UserRequests.Get["returns"];
  onUpdate: (props: _Api._UserRequests.Get["returns"]) => void;
};

export function TableSentRequests(props: Props) {
  const $info = createMemo(() => {
    const user_requests = props.details;
    return {
      role: user_requests.role,
      requests: user_requests.sent_requests,
    };
  });
  return (
    <Table
      _items={$info().requests}
      _fallback={<EmptyTable msg="You do not have any invitations currently " />}
      _class={{
        desktop: {
          table: "border-spacing-y-2 border-spacing-x-1 pt-0",
          thead: "h-2rem font-semibold text-0.77rem",
          theadTrTh: "px-4",
          theadBase: "bg-bg-alt rounded-t-6",
          tbodyTr: "text-0.75rem  overflow-hidden ring-border-card ring-2 rounded-3",
          tbodyTrTd: "items-center py-2 px-4 overflow-hidden",
        },
        phone: {
          wrapper: "gap-y-3 py-2 px-0.5 ",
          card: "items-center shadow-md py-2 px-2 gap-y-2 rounded-xl !justify-between text-0.8rem ring-border-card ring-2",
          header: "w-100px",
          cell: "justify-start overflow-x-auto",
        },
      }}
      _headers={{
        "Team Name": {
          hide: $info().role === "leader",

          key: ({ item }) => {
            return !item.team ? "No Team" : item.team;
          },
        },
        [$info().role === "leader" ? "User" : "Leader"]: {
          class: {
            desktop: {
              // th: "min-w-250px",
              th: "w-250px",
            },
          },
          hideHeader: {
            phone: true,
          },
          key: ({ item }) => {
            const image = typeof item.image !== "string" ? IconNoProfileImage : item.image;
            return <span class="font-bold text-0.8rem whitespace-nowrap">{`${item.name ?? "Unknown Name"}`}</span>;
          },
        },
        "Email Address": {
          class: {
            desktop: {
              th: "whitespace-nowrap",
            },
          },
          key: "email",
        },
        Action: {
          key: ({ item }) => {
            return (
              <div class="flex flex-row space-x-2">
                <span
                  class="bg-error-shade text-error cursor-pointer rounded-2 px-2 py-1 <sm:(text-0.8em)"
                  onclick={() => {
                    global.store.actions.popop.pushConfirmDialog({
                      type: "warn",
                      message: `Are you sure you want to withdraw request sent to ${item.team ?? item.name}?!`,
                      events: {
                        async onConfirmed() {
                          return cancel_request.get({ id: item.id }).then(() => {
                            global.store.actions.toast.pushToast({
                              type: "success",
                              message: $info().role === "leader" ? "invitation cencelled!" : "request cancelled!",
                            });
                            const data = { ...props.details };
                            data.sent_requests = $info().requests?.filter((x) => x.id !== item.id);
                            props.onUpdate?.(data);
                          });
                        },
                      },
                    });
                  }}
                >
                  Cancel
                </span>
              </div>
            );
          },
        },
      }}
    />
  );
}
